<template>
  <button @click="$emit('click', $event)">
    <google-logo class="google-logo"/>
    <span>
      Sign in with Google
    </span>
  </button>
</template>

<script>
import GoogleLogo from '@/assets/google-logo.svg';

export default {
  name: 'GoogleSignInButton',
  components: {
    GoogleLogo,
  },
};
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@500&display=swap');

@import '@/styles/colors.scss';

$background: #ffffff;
$background-active: #eeeeee;
$text-color: #404040;
$focus-color: #4285F4;

button {
  align-items: center;
  background: $background;
  border-radius: 0.25rem;
  border: none;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  margin: 0.375rem;
  outline: none;
  padding: 0.5rem;
  transition: background .2s, box-shadow .2s;
  user-select: none;
  vertical-align: middle;

  span {
    color: $text-color;
    font-family: Roboto;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.25rem;
    margin: 0 0.25rem 0 0.625rem;
  }

  &:focus {
    box-shadow: 0 0 0.1875rem 0.1875rem $focus-color;
  }

  &:active {
    background: $background-active;
  }
}
</style>
